import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Table, Button, Input, Space, Popconfirm, Card, Typography } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import Layout from "../../ReusableComponents/Layout";
import getCompany from "../../Redux/APIs/CompanyAPIs/get";
import deleteCompany from "../../Redux/APIs/CompanyAPIs/delete";
import PaginationComponent from "../../ReusableComponents/Pagination/PaginationComponent";
import { Icons } from "../../Utils/icons-utils";

const { Title, Text } = Typography;

const Companies = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const service = JSON.parse(localStorage.getItem("service"));
  const [companies, setCompanies] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [page, setPage] = useState(0);
  const [paginationResult, setPaginationResult] = useState({
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 0,
    currentPage: 0,
  });

  const filterCompaniesDeletion = (id) => {
    setCompanies((prev) => prev.filter((cmp) => cmp._id !== id));
  };

  const currentServiceID = localStorage.getItem("currentServiceID");
  const currentServiceName = localStorage.getItem("currentServiceName");
  const condition = localStorage.getItem("popUp") === "true";

  const serviceID = condition ? currentServiceID : service?._id;
  const serviceName = condition ? currentServiceName : service?.name;
  const serviceIcon = condition ? Icons[currentServiceName] : Icons[service?.name];

  useEffect(() => {
    if (!serviceID) return;
    const delayDebounceFn = setTimeout(() => {
      dispatch(
        getCompany(serviceID, setCompanies, setPaginationResult, page, searchText)
      );
      localStorage.removeItem("company");
    }, 400);
    return () => clearTimeout(delayDebounceFn);
  }, [searchText, page]);

  const columns = [
    { title: "Organisation", dataIndex: "name", key: "name" },
    {
      title: "Address",
      key: "address",
      render: (_, record) =>
        `${record?.address?.town || ""}, ${record?.address?.postCode || ""}, ${record?.address?.county || ""}`,
    },
    {
      title: "",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => {
              localStorage.setItem("company", JSON.stringify(record));
              navigate("/addCompany");
            }}
          />
          <Popconfirm
            title="Are you sure you want to delete this company?"
            onConfirm={() => dispatch(deleteCompany(record._id, filterCompaniesDeletion))}
            okText="Yes"
            cancelText="No"
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Layout>
      <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
        <Card
          size="small"
          style={{ textAlign: "center", width: 100, flexShrink: 0 }}
          bodyStyle={{ padding: 8 }}
        >
          <img
            src={serviceIcon}
            alt={serviceName}
            style={{ width: 40, height: 40, objectFit: "contain" }}
          />
          <Text strong style={{ display: "block", fontSize: 11 }}>
            {serviceName}
          </Text>
        </Card>
        <Title level={5} style={{ margin: 0, flex: 1 }}>
          {serviceName}
        </Title>
        <Input
          placeholder="Search companies..."
          prefix={<SearchOutlined />}
          allowClear
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setPage(0);
          }}
          style={{ width: 250 }}
        />
        <Link to="/addCompany">
          <Button type="primary" icon={<PlusOutlined />}>
            Add Company
          </Button>
        </Link>
      </div>

      <PaginationComponent {...paginationResult} setPage={setPage} />

      <Table
        columns={columns}
        dataSource={companies}
        rowKey="_id"
        pagination={false}
        bordered
        size="middle"
      />
    </Layout>
  );
};

export default Companies;
